import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    projId = '',
    itemId = '',
    rows = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpi.saveReasonerItems, {
        projId,
        itemId,
        rows,
    }, options);
    if (error) return { error, status };
    return content || { projId, itemId };
};

